import { render, staticRenderFns } from "./sale-type.vue?vue&type=template&id=ca85fd3a&scoped=true"
import script from "./sale-type.vue?vue&type=script&lang=js"
export * from "./sale-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca85fd3a",
  null
  
)

export default component.exports